module.exports = __webpack_public_path__ + "static/media/majorG6.b411b49.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorG6.wav
// module id = AA/S
// module chunks = 0